import { FontWeight, Text } from '@lili/lili-frontend-common';

export const FailedUpload = () => {
  // @TODO - make sure this component is ready.
  return (
    <div>
      <Text.H9 className='text-text-brand-primary ' fontWeight={FontWeight.SEMIBOLD}>
        Upload Failed Placeholder
      </Text.H9>
    </div>
  );
};
